import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Event} from '../../../../generated/sales-terminal-client';
import {AuthService} from '../../../../services/auth/auth.service';
import {UtilService} from '../../../../services/util/util.service';
import {ViewService} from '../../../../services/view/view.service';
import {Privileges} from '../../../admin/privileges/privileges.constants';
import {EventService} from '../../../../services/event/event.service';
import {CartService} from '../../../../services/cart/cart.service';
import {S3UploaderRatios, S3UploaderTypes} from '../../../../components/s3/uploader/s3-uploader.types';

@Component({
  selector: 'app-card-item',
  templateUrl: './card-item.component.html',
  styleUrls: ['./card-item.component.scss']
})
export class CardItemComponent {
  private _event: Event;
  @Input()
  public set event(event: Event) {
    this._event = event;
    this.updateVariables();
  }
  public get event(): Event {
    return this._event;
  }
  @Output() public openEventDetails: EventEmitter<Event> = new EventEmitter<Event>();
  @Output() public openPurchaseView: EventEmitter<Event> = new EventEmitter<Event>();
  @Output() public openEventBookings: EventEmitter<Event> = new EventEmitter<Event>();

  public image: string;
  public isPresaleEnded: boolean;
  public isSoldOut: boolean;
  public isSaleStartsOn: boolean;
  public isSuspended: boolean;
  public isPresaleWithCode: boolean;
  public isTicketsUnavailable: boolean;
  public isRefundable: boolean;
  public canBuy: boolean;
  public isTicketsCurrentlyUnavailableState: boolean;
  public isSoldOutState: boolean;
  public isRefundableState: boolean;
  public isPostponed: boolean;
  public isPresaleEndedState: boolean;
  public needsWarningBadge: boolean;

  public actionsDisabled: boolean = true;
  public Privileges = Privileges;

  constructor(private utilService: UtilService,
              public authService: AuthService,
              public eventService: EventService,
              public cartService: CartService,
              public viewService: ViewService) {}

  private updateVariables(): void {
    this.image = this.eventService.getEventImage(this.event);
    this.isPresaleEnded = this.eventService.isPresaleEnded(this.event.substatusId);
    this.isSoldOut = this.eventService.isSoldOut(this.event.substatusId);
    this.isSaleStartsOn = this.event.boEvent ? this.eventService.isSaleStartsFuture(this.event.sale?.start) : this.eventService.isSaleStartsOn(this.event.substatusId);
    this.isSuspended = this.eventService.isSuspended(this.event.substatusId);
    this.isPresaleWithCode = this.eventService.isPresaleWithCode(this.event);
    this.isTicketsUnavailable = this.eventService.isTicketsUnavailable(this.event.substatusId);
    this.isRefundable = this.eventService.isRefundable(this.event.status.id);
    this.canBuy = this.eventService.canBuy(this.event);
    this.isTicketsCurrentlyUnavailableState = !this.isSaleStartsOn && this.eventService.isTicketsUnavailableState(this.event.assignedStates);
    this.isSoldOutState = this.eventService.isSoldOutState(this.event.assignedStates);
    this.isRefundableState = this.eventService.isRefundableState(this.event.assignedStates);
    this.isPostponed = this.eventService.isPostponedState(this.event.assignedStates);
    this.isPresaleEndedState = this.eventService.isPresaleEndedState(this.event.assignedStates);
    this.needsWarningBadge = this.isSoldOut || this.isSuspended || this.isSoldOutState || this.isTicketsCurrentlyUnavailableState || this.isPostponed || this.isRefundableState || this.isPresaleEndedState;
  }

  get warningBadgeText(): string {
    if (this.isSuspended) return 'general.api_sales_suspended';
    if (this.isSoldOut || this.isSoldOutState) return 'general.api_sales_sold_out';
    if (this.isTicketsCurrentlyUnavailableState) return 'general.api_sales_TICKETS_CURRENTLY_UNAVAILABLE';
    if (this.isPostponed) return 'general.api_events_event_state_POSTPONED';
    if (this.isRefundableState) return 'general.api_events_event_state_REFUNDABLE';
    if (this.isPresaleEndedState) return 'general.api_events_event_state_PRE_SALE_ENDED';
  }

  public get mobileActionsDisabled(): boolean {
    return this.actionsDisabled && this.utilService.isMobile;
  }

  public get isCardFadedOut(): boolean {
    return this.eventService.isFadedOut(this.event, this.cartService.cartDraftEvent);
  }

  protected readonly S3UploaderTypes = S3UploaderTypes;
  protected readonly S3UploaderRatios = S3UploaderRatios;
}
